'use client'
import { LoadingOverlay } from '@/components/Loading/Overlay'

const LoadingPage = () => <LoadingOverlay isLoading={true} />

export default LoadingPage